import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const AuthContext = createContext(null);
const KEY = "wre_admin_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const authAxios = useCallback(() => {
    const t = localStorage.getItem(KEY);
    return axios.create({
      baseURL: API,
      headers: t ? { Authorization: `Bearer ${t}` } : {},
    });
  }, []);

  const refreshMe = useCallback(async () => {
    const t = localStorage.getItem(KEY);
    if (!t) { setUser(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setUser(data.user);
    } catch (e) {
      localStorage.removeItem(KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await refreshMe();
      setReady(true);
    })();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, authAxios }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
